import { AxiosInstance } from '@service/axios-instance';

export async function addDevice({ device_name }: { device_name: string }) {
  try {
    const response = await AxiosInstance.post(
      '/devices/add',
      { device_name },
      {
        withCredentials: true,
      }
    );

    return response.data; // Return only the response data
  } catch (error) {
    console.error('Error creating device:', error);
    throw error; // Reject the promise with the error to handle it later
  }
}

export function getDevices() {
  const response = AxiosInstance.get('/devices/get_info', {
    withCredentials: true,
  }
  ).then((res) => res
  ).catch( e => {alert("get_info error")} );

  return response;
}

export async function deleteDevice({ device_name }: { device_name: string }) {
  try {
    const response = await AxiosInstance.delete('/devices/delete', {
      data: {
        device_name,
      },
      withCredentials: true,
    });

    return response.data; // Return only the response data
  } catch (error) {
    console.error('Error deleting device:', error);
    throw error; // Reject the promise with the error to handle it later
  }
}
